export * from './register-device-dialog.component';
